import React from 'react';
import tabsContentStyles from './TabsContentStyles.module.css';

export function TabsContent(props) {
  return <div className={tabsContentStyles['tabs-content']}>{props.children}</div>;
}
